import asyncThunk from '@/lib/asyncThunk'
import { Result } from '@/out/result'

type Request = {
  customerRef: string
}

export const listResultsByCustomer = asyncThunk<Request, Result[]>({
  name: 'results/customer',
  uri: '/results/customer',
})
